module.exports = __webpack_public_path__ + "HP_Latex_700-800_car_wrapping.jpg?c6f6dbff90194645afed1ea4714d2b86";